export const summaryState = {
  isSummary: false,
  summaryData: null
};

export const institutionsState = {
  treeData: [],
  rosterTree: []
};

export const emailState = {
  templates: null,
  emailObject: null,
  emailStatus: null,
  reasons: null,
  psr: []
};
